import AIResponseSuggestions from "./AIResponseSuggestions";
export default AIResponseSuggestions;
